import { isDefinedRoute, resolveNavHref } from './matchRoute'

function pathMatchesHref(pathname: string, href: string): boolean {
  return pathname === href || pathname.startsWith(`${href}/`)
}

/**
 * Active nav item is derived from the route that actually rendered:
 * - pathname must match a defined route (NotFound / known-missing → nothing active)
 * - among defined nav hrefs that prefix-match pathname, pick the longest
 */
export function getActiveNavHref(pathname: string, hrefs: readonly string[]): string | null {
  if (!isDefinedRoute(pathname)) return null

  let best: string | null = null
  for (const href of hrefs) {
    if (resolveNavHref(href) !== 'defined') continue
    if (!pathMatchesHref(pathname, href)) continue
    if (!best || href.length > best.length) best = href
  }
  return best
}

export function isNavItemActive(pathname: string, href: string, allHrefs: readonly string[]): boolean {
  return getActiveNavHref(pathname, allHrefs) === href
}
